import { Component, OnInit, Input } from '@angular/core';


export class ZrProgressComponent implements OnInit {
  // progress data
   progress: any;
  // progress type (line or circle)

   type?: string = 'line';
  // progress height (when linear, available)

   lineHeight?: number = 6;
  // text show methods (inside or outside)

   textInside?: string = 'outside';
  // progress background

   backGround?: string = '#409EFF';
  // is show text?

   textShow?: boolean = true;
  // progress width (when circle,available)

   width?: number = 126;
  // progress status

   status?: any;

  constructor() { }

  ngOnInit() { }

  setLineHeight() {
    if (this.textInside === 'inside') {
      if (this.lineHeight && this.lineHeight <= 6) {
        return `20px`;
      } else {
        return `${this.lineHeight}px`;
      }
    } else {
      return `${this.lineHeight}px`;
    }
  }

  setBackGround() {
    if (this.progress === 100) {
      return `#67C23A`;
    } else if (this.backGround === '#409EFF') {
      return `#409EFF`;
    } else {
      return this.backGround;
    }
  }

  setWidth() {
    if (this.width && this.width <= 126) {
      return '126px';
    } else {
      return `${this.width}px`;
    }
  }

  setCircleProgress() {
    return `${299.08 - this.progress * (299.08 / 100)}px`;
  }

  setStrokeColor() {
    if (this.progress === 100) {
      return `#67C23A`;
    } else if (this.status === 'exception') {
      return `#FF4949`;
    } else if (this.backGround !== '#409EFF') {
      return this.backGround;
    } else {
      return `#409EFF`;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'zr-progress',
  template: `
  <div *ngIf="type==='line'" class="lz-progress">
    <div class="lz-progress-bar">
      <div class="lz-progress-bar__outer" [ngStyle]="{'height':setLineHeight()}">
        <div class="lz-progress-bar__inner" [ngStyle]="{'background-color':setBackGround(),'width': progress + '%'}">
          <div *ngIf="textInside==='inside'&&textShow===true" [ngStyle]="{'color':'#fff'}" class="lz-progress__text">{{progress}}%</div>
        </div>
      </div>
    </div>
    <div *ngIf="textInside==='outside'" [ngStyle]="{'color':'#5a5e66'}" class="lz-progress__text">
      <span *ngIf="progress!==100&&textShow===true">{{progress}}%</span>
      <i *ngIf="progress===100" [ngStyle]="{'color':'#67C23A'}" class="la la-check-circle"></i>
    </div>
  </div>

  <div *ngIf="type==='circle'" class="lz-progress text-center" [ngStyle]="{'margin':'auto','width':setWidth(),'height':setWidth()}">
    <svg viewBox="0 0 100 100">
      <path fill="none" stroke="#e5e9f2" d="M 50 50 m 0 -47 a 47 47 0 1 1 0 94 a 47 47 0 1 1 0 -94"
        stroke-width="4.8"></path>
      <path class="lz-circle__inner" fill="none" stroke-linecap="round" d="M 50 50 m 0 -47 a 47 47 0 1 1 0 94 a 47 47 0 1 1 0 -94"
        stroke-width="4.8" [ngStyle]="{'stroke-dashoffset': setCircleProgress(),'stroke': setStrokeColor()}"></path>
    </svg>
    <div class="lz-circle-progress__text">
        <span *ngIf="progress!==100&&status!=='exception'">{{progress}}%</span>
        <i *ngIf="progress===100" [ngStyle]="{'color':'#67C23A'}" class="la la-check"></i>
        <i *ngIf="status==='exception'" [ngStyle]="{'color':'#FF4949'}" class="la la-close"></i>
    </div>
  </div>
`,
  styles: [
    `
      .lz-progress {
        position: relative;
        line-height: 1;
      }

      .lz-progress-bar {
        display: inline-block;
        vertical-align: middle;
        padding-right: 50px;
        width: 100%;
        margin-right: -55px;
        box-sizing: border-box;
      }

      .lz-progress-bar__outer {
        position: relative;
        border-radius: 100px;
        background-color: #e6ebf5;
        overflow: hidden;
        vertical-align: middle;
      }

      .lz-progress-bar__inner {
        position: absolute;
        left: 0;
        top: 0;
        width: 20%;
        height: 100%;
        text-align: right;
        border-radius: 100px;
        line-height: 1;
      }

      .lz-progress__text {
        font-size: 14px;
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        line-height: 1;
      }

      .lz-progress-bar__inner:after {
        content: '';
        display: inline-block;
        vertical-align: middle;
        height: 100%;
      }

      .lz-circle__inner {
        stroke-dasharray: 299.08px, 299.08px;
        transition: stroke-dashoffset 0.6s ease 0s, stroke 0.6s ease;
      }

      .lz-circle-progress__text {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        text-align: center;
        margin: 0;
        transform: translateY(-50%);
      }
    `
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'progress': [{ type: Input },],
'type': [{ type: Input },],
'lineHeight': [{ type: Input },],
'textInside': [{ type: Input },],
'backGround': [{ type: Input },],
'textShow': [{ type: Input },],
'width': [{ type: Input },],
'status': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
